module.exports = __webpack_public_path__ + "static/media/portfolio1.27473693.jpg";